import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';

/**
 * Dashboard header component with title and action button
 */
const DashboardHeader = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-8">
      <div>
        <h1 className="text-3xl font-bold text-text-primary">Company Management</h1>
        <p className="text-text-secondary mt-1">Manage all epoxy companies and their configurations</p>
      </div>
      <Button
        variant="default"
        onClick={() => navigate('/company-create-edit')}
        iconName="Plus"
        iconPosition="left"
        iconSize={18}
      >
        Add New Company
      </Button>
    </div>
  );
};

export default DashboardHeader;